
export default () => {

  if ($('.map__opener').length) {
    $.ajax({
      url: $('.map__opener.active').data('link'),
      type: 'json',
      method: 'GET',
      success: (data) => {
        buildMap(data);
      }
    });

    $(document).on('click','.map__opener:not(.active)', function() {
      const link = $(this).data('link');
      $(".map__opener").removeClass("active");
      $(this).addClass('active');
      if (link) {
        $(".map__city-list").html("");
        $.ajax({
          url: link,
          type: 'json',
          method: 'GET',
          success: (data) => {
            buildMap(data);
            window.BinotelCallTracking[506208].replacePhoneNumbersOnDynamicContent()
          }
        });
      } else {
        console.error('No link to map!');
      }
    });
  }
  const buildMap = (data) => {
    for (let i = 0; i < data.length; i++) {
      const lang = $('html').attr('lang');
      var lang1;
      if (lang === 'uk') {
        var lang1 = 'Нд';
        var lang2 = "замовити дзвінок";
      }
      if (lang === 'ru-RU') {
        var lang1 = 'Вc';
        var lang2 = "заказать звонок";
      }
    const tplItem = `
      <div class="map-section">
        <div class="map-section__info">
          <div class="map-section__contacts">
            <div class="map-section__name">${data[i].name}</div>
            <address class="map-section__address">${data[i].address}</address>
            <ul class="map-section__phones">
              <li><a href="tel:${data[i].telhref}">${data[i].tel}</a></li>
              <li><a href="tel:${data[i].telhref2}">${data[i].tel2}</a></li>
              <li><a href="tel:${data[i].telhref3}">${data[i].tel3}</a></li>
              <li><a href="tel:${data[i].telhref4}">${data[i].tel4}</a></li>
            </ul>
          </div>
          <div class="map-section__work">
            <ul class="map-section__work-day">
              <li>Пн</li>
              <li>Вт</li>
              <li>Ср</li>
              <li>Чт</li>
              <li>Пт</li>
              <li class="${data[i].specialDay}">Сб</li>
              <li class="map-section__work-custom">${lang1}</li>
            </ul>
            <div class="map-section__time">${data[i].weekdays}</div>
            <div class="map-section__time">${data[i].weekends}</div>
            <div class="map-callback">${lang2}</div>
          </div>
        </div>
        <div class="map" coordinates="${data[i].coordinates}"></div>
      </div>`;

      $(".map__city-list").append(tplItem);
    }

    $('.map').each(function (index, Element) {
      var coords = $(Element).attr('coordinates').split(",");

      var latlng = new google.maps.LatLng(coords[0], coords[1]);
      var myOptions = {
        zoom: 17,
        center: latlng,
        scrollwheel: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        styles: [
          {
            featureType: "all",
            elementType: "all",
            stylers: [

            ]
          }
        ]
      };
      var map = new google.maps.Map(Element, myOptions);

      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: {
          url: $('.map__city-list').data('marker'),
          scaledSize: new google.maps.Size(24, 28)
        }
      });
    });

    $(".map-section__phones li a").each(function (index, element) {
      if ($(element).html().trim() === '') {
        $(element).parent().addClass('hide');
      }
    });
    // $(".shop__tel").parent('.shop__row-box').each(function (index, element) {
    //   let elementDiv = $(element).find("a").length;
    //   let elementHide = $(element).find(".hide").length;
    //   if (elementDiv === elementHide) {
    //     $(element).parents('.shop__row').remove();
    //   }
    // });
    // $(".shop__text").each(function(index, element) {
    //   if ($(element).html().trim() === '') {
    //     $(element).next(".comma").addClass('hide');
    //     $(element).prev(".shop__time-text").addClass('hide');
    //     $(element).addClass('hide');
    //   }
    // });
    // $(".shop__time").each(function (index, element) {
    //   let elementDiv = $(element).find("div").length;
    //   let elementHide = $(element).find(".hide").length;
    //   if (elementDiv === elementHide) {
    //     $(element).parents('.shop__row').remove();
    //   }
    // });
  };
};



// WEBPACK FOOTER //
// app/scripts/components/map.js